import React, { useEffect } from 'react'

const AddBroker = () => {
    useEffect(() => {
        // Initialize intl-tel-input when the component mounts
        const input = document.querySelector("#mobilebroker");
        const iti = window.intlTelInput(input, {
            preferredCountries: ["us", "gb", "in", "au"],  // Customize preferred countries
            utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@17.0.8/build/js/utils.js"  // For better validation and formatting
        });

        // Cleanup the intl-tel-input when the component unmounts
        return () => {
            if (iti) {
                iti.destroy();
            }
        };
    }, []);
    return (
        <div>
            <div className="modal fade" id="addBrokerModal" tabindex="-1" aria-labelledby="addLeadModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header" >
                            <h5 className="modal-title font-bold" id="addLeadModalLabel">Add Broker </h5>
                            <button type="button" className="btn-close btn-close-primary size-10" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="first-section">
                            <div className="row mb-3">
                                    <div className="col-md-6">
                                        <label for="name" className="form-label">Name (*)</label>
                                        <input type="text" className="form-control" id="name" placeholder="Enter broker name" />
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <label for="mobile" className="form-label">Mobile No (*)</label>
                                        <input type="tel" className="form-control" id="mobilebroker" placeholder="Enter mobile number" />
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <label for="f_name" className="form-label">Firm Name (*)</label>
                                        <input type="text" className="form-control" id="f_name" placeholder="" />
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <label for="brokerage_per" className="form-label">Brokerage per</label>
                                        <input type="text" className="form-control" id="brokerage_per" placeholder="" />
                                    </div>
                                    <div className="col-12 mt-3">
                                        <label for="remarks" className="form-label">Remarks (*)</label>
                                        <textarea className="form-control" id="remarks" rows="3"></textarea>
                                    </div>
                                </div>
                              
                            </div>

                          
                        </div>
                        <div className="modal-footer justify-content-between p-3" style={{ borderTop: "2px solid #f0f0f0" }}>
                            <button
                                type="button"
                                className="btn btn-outline-primary d-flex align-items-center gap-2"
                                style={{ borderRadius: "30px", padding: "0.5rem 1.5rem" }}
                                data-bs-dismiss="modal"
                            >
                                <i className="bi bi-x-circle"></i> Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-gradient d-flex align-items-center gap-2"

                                style={{ borderRadius: "30px", padding: "0.5rem 1.5rem", background: "linear-gradient(90deg, #6a11cb 0%, #313265 100%)", color: "white", border: "none" }}
                            >
                                <i className="bi bi-plus-circle"></i>  Add
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddBroker
